import { Component, OnInit, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { HttpService } from '../../services/http/http-service.service';
import { NzMessageService } from 'ng-zorro-antd';
import { SFileViewerService } from '../s-file-viewer/s-file-viewer.service';
import { CommonService } from '../../services/common/common.service';
@Component({
  selector: 'app-s-export-code',
  templateUrl: './s-export-code.component.html',
  styleUrls: ['./s-export-code.component.less']
})
export class SExportCodeComponent implements OnInit {
  @Input() exportCodeConfig;
  @ViewChild('host', { read: ViewContainerRef }) host: ViewContainerRef;
  constructor(
    private httpService: HttpService,
    private message: NzMessageService,
    private fileViewerService: SFileViewerService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {

  }

  export() {
    const url = `${this.exportCodeConfig.url}/${this.exportCodeConfig.id}`;
    this.commonService.downLoad(url, 'GET');
  }

  showBigPic(url) {
    const obj = { host: this.host, type: 'jpg', src: url };
    this.fileViewerService.handleView(obj);
  }

}
